import { Routes, Route, BrowserRouter as Router, useLocation } from 'react-router-dom';
import BrandDetails from "./dashboard/brands/BrandDetails";
//import Brands from "./dashboard/brands/Brands";

import EnterpriseCustomers from "./dashboard/customers/enterprise/EnterpriseCustomers";
import RetailCustomers from "./dashboard/customers/retail/RetailCustomers";

import Dashboard from "./dashboard/Dashboard";
import Dealers from "./dashboard/dealers/Dealers";
import Downloads from "./dashboard/downloads/Downloads";
import EnquiryFormData from "./dashboard/enquiry/EnquiryFormData";
import Categorydetails from "./dashboard/main_categories/CategoryDetails";
//import MainCategories from "./dashboard/main_categories/MainCategorys.js";
import NotificationsData from "./dashboard/notifications/NotificationsData";
import OrdersTable from "./dashboard/orders/OrdersTable";
import PaymentsData from "./dashboard/payments/PaymentsData";
import ProductDetails from "./dashboard/products/details/ProductDetails";
import ProductsTable from "./dashboard/products/reactTablePagination"; //reactTableTwo;
import ProductSizesTable from "./dashboard/sizes/ProductSizes";
import ProductSubCategories from "./dashboard/sub_categories/SubCategories.js";
import SubCategorydetails from "./dashboard/sub_categories/SubCategoryDetails";
//import UsersList from "./dashboard/customers/EnterpriseCustomers";
//import UserDetails from "./dashboard/users/UserDetails";
import Login from "./login/Login";
import OrderDetails from "./dashboard/orders/OrderDetails";
import BrandsList from './dashboard/brands/BrandsList';
import MainCategoriesTable from './dashboard/main_categories/MainCategoryList';
import SubCategoriesTable from './dashboard/sub_categories/SubCategoryList';
import FinishesTable from './dashboard/finishes/FinishesList';
import FinishesDetails from './dashboard/finishes/finishesdetails';
import SizeDetails from './dashboard/sizes/SizeDetails';
import BatchProcessing from './dashboard/batchprocessing/batchdetails';
import StockUpload from './dashboard/batchprocessing/StockUpload';
import EnterpriseAccountDetails from './dashboard/customers/enterprise/EnterpriseAccountDetails';
import CatalogueList from './dashboard/catalogues/CatalogueList';
import CatalogueDetails from './dashboard/catalogues/CatalogueDetails';
import { NotificationPage } from './dashboard/orders/NotificationPage';
import { EnterpriseNotifPage } from './dashboard/customers/enterprise/EnterpriseNotifPage';
import NotificationList from './dashboard/notifications/NotificationList';
import { NotificationsListPage } from './dashboard/notifications/NotificationsListPage';
import { BatchProcessingPage } from './dashboard/batchprocessing/BatchProcessingPage';
import DownloadProductTableData from './dashboard/downloadproducttabledata/DownloadProductTableDataPage';
import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import { hideOptions } from "./utils/config";
import SalesRepList from './dashboard/customers/sales/SalesRepList';
import SalesRepDetails from './dashboard/customers/sales/SalesRepDetails';
import SalesFeedBackList from './dashboard/customers/feedback/SalesRepFeedBackList';
import SalesRepFeedbackDetails from './dashboard/customers/feedback/SalesRepFeedbackDetails';
import { NotificationPageQuote } from './dashboard/quotations/NotificationPageQuote';
import QuotationDetails from './dashboard/quotations/QuotationDetails';

export default function Routing() {

  const [hideNavigation, setHideNavigation] = useState(true);


  useEffect(() => {

    {
        //alert(hideOptions())
        setHideNavigation( hideOptions());
   }
  }, []);



  // const location = useLocation();
  return (

    <Router basename={'/etna'}>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="login" element={<Login />} />
        <Route path='home' element={<Dashboard />}>


          {!hideNavigation && <Route path="subcategorydetails" element={<SubCategorydetails />} />}
          {!hideNavigation && <Route path="sub_categories" element={<SubCategoriesTable />} />}


          {!hideNavigation && <Route path="categories" element={<MainCategoriesTable />} />}
          {!hideNavigation && <Route path="categoriesdetails" element={<Categorydetails />} />}


          {!hideNavigation && <Route path="brands" element={<BrandsList />} />}
          {!hideNavigation && <Route path="branddetails" element={<BrandDetails />} />}

          {!hideNavigation && <Route path="finishes" element={<FinishesTable />} />}
          {!hideNavigation && <Route path="finishesdetails" element={<FinishesDetails />} />}



          {!hideNavigation && <Route path="sizes" element={<ProductSizesTable />} />}
          {!hideNavigation && <Route path="sizedetails" element={<SizeDetails />} />}


          {!hideNavigation && <Route path="retail" element={<RetailCustomers />} />}

          {!hideNavigation && <Route path="salesrep" element={<SalesRepList />} />}
          {!hideNavigation && <Route path="salesrepdetails" element={<SalesRepDetails />} />}

          {!hideNavigation && <Route path="dealers" element={<Dealers />} />}

          {!hideNavigation && <Route path="payments" element={<PaymentsData />} />}
          {!hideNavigation && <Route path="notifications" element={<NotificationsData />} />}
          {!hideNavigation && <Route path="downloads" element={<Downloads />} />}
          {!hideNavigation && <Route path="enquiry" element={<EnquiryFormData />} />}
          {!hideNavigation && <Route path='products' element={<ProductsTable />}> </Route>}

          {!hideNavigation && <Route path='products/:brand' element={<ProductDetails />}></Route>}
          {!hideNavigation && <Route path='products/:brand/:category/:modelNum/:action' element={<ProductDetails />}></Route>}
          
          {!hideNavigation && <Route path='productdetails' element={<ProductDetails />}></Route>}
          {!hideNavigation && <Route path='batchprocessing' element={<BatchProcessingPage />}></Route>}
          {!hideNavigation && <Route path='stockupload' element={<StockUpload />}></Route>}


          {!hideNavigation && <Route path='catalogues' element={<CatalogueList />}> </Route>}
          {!hideNavigation && <Route path="cataloguedetails" element={<CatalogueDetails />} />}

          {!hideNavigation && <Route path="salesfeedbacklist" element={<SalesFeedBackList />} />}

          {!hideNavigation && <Route path="salesRepFeedbackDetails" element={<SalesRepFeedbackDetails />} />}


           <Route path='orders/:entId/:orderId/:selectedStatus' element={<OrderDetails />}></Route>
           <Route path="orders" element={<NotificationPage />} />
           <Route path="quotations" element={<NotificationPageQuote />} /> 
           <Route path='quotations/:entId/:quoteId' element={<QuotationDetails />}></Route>
           <Route path="neworders" element={<NotificationPage />} />

          {!hideNavigation && <Route path="enterprise" element={<EnterpriseNotifPage />} />}
         {/* {!hideNavigation && <Route path="newenterprise" element={<EnterpriseNotifPage />} />} */}

          <Route path="newnotifications" element={<NotificationsListPage />} />

          <Route path='newnotifications/:entId/:orderId/:selectedStatus' element={<OrderDetails />}></Route>

          {!hideNavigation && <Route path='enterpriseAccountdetails' element={<EnterpriseAccountDetails />}></Route>}

          {!hideNavigation && <Route path='downloadproducttabledata' element={<DownloadProductTableData />}></Route>}


        </Route>
      </Routes>
    </Router>
  )
}